import mitt from 'mitt';

let emitter = mitt();
let chunkNumberForSEEEvent = 0;

function resetEmitter() {
  emitter.all.clear();
  emitter = mitt();
}
function emitEvent(event, data) {
  emitter.emit(event, data);
}
function setChunkNumberForSEEEvent(chunkNumber) {
  chunkNumberForSEEEvent = chunkNumber;
}
export {
  emitter,
  resetEmitter,
  emitEvent,
  chunkNumberForSEEEvent,
  setChunkNumberForSEEEvent,
};
